export default __webpack_public_path__ + "img/TechCrunch.57d0fcba.svg";